import { Component, OnInit } from '@angular/core';
import EncryptStorage from 'encrypt-storage';
import * as moment from 'moment';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalRef} from 'ng-zorro-antd/modal';
import { AuthService, } from 'src/app/auth/auth.service';
import { DateRange, MomentHelper } from 'src/app/models/date';
import { RequestedSearch } from 'src/app/models/requested-payments';
import { DownloadService } from 'src/app/reports/download-service';
import { AvailableOptions, emptyFields, productTypeAllOptions, ReportTerminals, TierOptions, UsersType, UserTypes } from 'src/app/utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { Messages } from 'src/app/utilities/message';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { PaymentService } from '../payment.service';
export const encryptStorage = EncryptStorage('secret_key', {
  storageType: 'localStorage'
});
@Component({
  selector: 'app-requested-payment',
  templateUrl: './requested-payment.component.html',
})
export class RequestedPaymentComponent implements OnInit {
  private tableData: NzTableData<RequestedSearch, any> = new NzTableData<RequestedSearch, any>(new RequestedSearch(), 'status');
  loading = false;
  merchantId: any;
  locationId: any;
  hashId:any;
  notifyLogout: any;
  selectedMerchantProduct: any;
  emptyField = emptyFields;
  availableOptions=AvailableOptions;
  showDownload: string;
  downloadList = [];
  userRole=UserTypes;
  role :string;
 userType = UsersType;
  locationsList = [];
  productModal: NzModalRef;
  loginUserType = '';
  showAppCodeFilter = false;
  name:any;
  selectedRateDateRange: Date[] = null;
  constructor(public paymentService: PaymentService,
  public authService: AuthService,
  public commonService: CommonService,
  public notification: NzNotificationService,
  public downloadService: DownloadService,
  ) { }

  ngOnInit() {
    this.loginUserType = this.authService.getRole();
    this.tableData.search.merchantId = this.authService.getMerchantId();
    if(this.role === this.userRole.merchant){
      this.locationsList = this.authService.getLocationDetails();
      }else{
       this.tableData.search.locationId = '';
       }
    this.getLocations();
    this.refresh();
  }

// For List
refresh(startFromPageOne: boolean = true): void {
  this.loading = true;
  this.tableData.data = [];
  if (startFromPageOne) {
    this.tableData.pageIndex = 1;
  }
  this.tableData.search.merchantId = this.merchantId;
  if (this.loginUserType !== this.userType.merchantUser) {
     // this.tableData.search.locationId = this.authService.getLocationId();
     let locationId = this.authService.getLocationDetails();
     this.tableData.search.locationId=(locationId[0].hashId);
  }
  this.paymentService.getRequestedPaymentslist(this.tableData).subscribe((response: any) => {
    console.log("reeeee",response);
    
    this.loading = false;
    this.tableData.total = response.data.total;
    if (response.data && response.data.merchantLocationPayments) {
      this.tableData.data = response.data.merchantLocationPayments;
      this.showDownload = Messages.downloadReport;
    } else {
      this.tableData.data = [];
      this.showDownload = '';
    }
  }, (err) => {
    this.loading = false;
    this.tableData.data = [];
    this.showDownload = '';
  });
}

  // For Page index change
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.refresh(false);
  }

// To clear search fields
clearSearch(value) {
  return this.paymentService.clearSearchFields(this.tableData, value);
}

// For Changing Date range
onUpdatedOnChange(range: any[]) {
  if (range.length <= 1) { return; }
  this.tableData.search.createdDate = MomentHelper.createDateRange(range);
  this.tableData.search.startDate = this.tableData.search.createdDate.startDate ? this.tableData.search.createdDate.startDate : '';
  this.tableData.search.endDate = this.tableData.search.createdDate.endDate ? this.tableData.search.createdDate.endDate : '';
  this.refresh();
}
updateClear(range: any[]) {
  if (range.length <= 1) {
    this.tableData.search.createdDate = DateRange.empty();
    this.tableData.search.startDate='';
    this.tableData.search.endDate='';
    return;
}
}

//LOCATION LIST
getLocations() {
  this.locationsList = this.authService.getLocationDetails();
  }
  sort(sort: { key: string; value: string }): void {
    this.tableData.setSort(sort);
    this.refresh();
  }
    // To Show Status
    merchantPaymentStatus(status) {
    return this.commonService.getMrechantPaymentTypeStatus(status);
  }

  // For User Status Tag color
  getStatusColor(status) {
    return this.commonService.getColorForMerchantPayment(status);
  }

  // PaymentMethod
getPaymentMethod(mode) {
  return this.commonService.getPaymentMethod(mode);
}

// PaymentMethodColor
getColorForPaymentMethod(mode) {
  return this.commonService.getColorForPaymentMethod(mode);
}

 // For Download Excel
 downloadReport() {
  if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
  this.notification.info('Download Processing', 'Please Wait', {
    nzKey: 'key'
  });
  const value = {
    paymentId: this.tableData.search.paymentId ? this.tableData.search.paymentId : '',
    startDate: this.tableData.search.startDate,
    endDate: this.tableData.search.endDate,
    merchantId: this.tableData.search.merchantId ? this.tableData.search.merchantId : '',
    locationId: this.tableData.search.locationId ? this.tableData.search.locationId : '',
    customerName:this.tableData.search.customerName ? this.tableData.search.customerName : '',
    phoneNumber:this.tableData.search.phoneNumber ? this.tableData.search.phoneNumber : '',
    email:this.tableData.search.email? this.tableData.search.email : '',
  };
  // For filter headers
  const filterHeaders = ['Payment ID','Created On','Location'];

  // To Show Filtered data
  const filterData = [
     value.paymentId ? value.paymentId : '',
     value.startDate && value.endDate ? moment(value.startDate).local().format('DD-MMM-YYYY') + ' to ' +
    moment(value.endDate).local().format('DD-MMM-YYYY') : '',
    this.tableData.search.locationId ? this.locationsList.find(x => x.hashId === this.tableData.search.locationId).name : 'All',
    value.customerName ? value.customerName:'',
     value.phoneNumber ? value.phoneNumber:'',
     value.email ? value.email:'',
  ];
  // API request
  this.paymentService.downloadRequestedPaymentReport(value).subscribe((response: any) => {
     this.downloadList = response.data.merchantLocationPayments;
    if (this.downloadList.length > 0) {
       const headers = ['ID','Order Number','Payment ID','Amount','Payment Method','Status','Expiry Time','Customer Name','Phone Number','Email ID','Created Date','Created By', 'Updated Date', 'Updated By'];

      this.downloadService.onDownloadExcel(headers, ReportTerminals.merchantRequestedPaymentList, this.tableData.search.createdDate.startDate,
        this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.merchantRequestedPaymentList,
        ReportTerminals.merchantRequestedPaymentList, filterHeaders, filterData);
    }
  });
}else{
  this.notification.error(Messages.noDateSelected, '', {
    nzKey : 'key'
  });
}
}
}
